import flatten from 'flat'

const target = {
	global: {
		title: 'VISITEL',
		surface: ' m²'
	},
	errors: {
		required: 'Requis*',
		formatEmail: 'Format du courriel incorrect',
		dejaExistant: 'Création de compte non autorisée pour ce courriel'
	},
	selectionPanel: {
		btn: 'Nouvelle recherche',
		offer: {
			title: 'Recherche par offre',
			search: 'Rechercher une offre'
		},
		client: {
			title: 'Recherche par prospect',
			search: 'Rechercher un contact'
		},
		change: 'Changer'
	},
	lot: {
		details: {
			completeCategory: {
				twoPieces: '2 pièces',
				threePieces: '3 pièces',
				fourPieces: '4 pièces',
				fivePieces: '5 pièces',
				sixPieces: '6 pièces',
				sevenPieces: '7 pièces',
				auditorium: 'auditorium',
				shop: 'boutique',
				doubleBox: 'box double',
				motoBox: 'box moto',
				noRentBox: 'box non louable',
				smallBox: 'box petit',
				simpleBox: 'box simple',
				desk: 'bureau',
				homeDesk: 'bureau d\'accueil gardien',
				cafe: 'cafétéria',
				cave: 'cave',
				logistic: 'cellule logistique',
				bedroom: 'chambre',
				bedroomService: 'chambre de service',
				hospital: 'clinique / Hôpital',
				concierge: 'conciergerie',
				clearance: 'dégagements',
				enseigne: 'emplacement pour enseigne',
				panel: 'emplacement pour panneau',
				phone: 'emplacement radio téléphone',
				dock: 'entrepôt',
				hostOldDepend: 'etablissement d\'Hébergement de Pers Agées Dépendante',
				hostOld: 'etablissement d\'Hébergement de Personnes Agées',
				hostel: 'hôtel',
				laboratory: 'laboratoire',
				laundromat: 'laverie',
				commercialLocal: 'local commercial',
				activityLocal: 'local d\'activité',
				archivesLocal: 'local d\'archives',
				receptionLocal: 'local de réception',
				serviceLocal: 'local de service',
				diversLocal: 'local divers',
				functionalLocal: 'local fonctionnel',
				trashLocal: 'local poubelles',
				professionalLocal: 'local professionnel non louable en appartement',
				technicalLocal: 'local technique',
				bicycleLocal: 'local vélos',
				noPatrimonialPanel: 'panneau en co-propriété hors patrimoine',
				doubleInternalParking: 'couvert double',
				motoInternalParking: 'couvert moto',
				noRentInternalParking: 'couvert non louable',
				smallInternalParking: 'couvert petit',
				simpleInternalParking: 'couvert simple',
				doubleExternalParking: 'extérieur double',
				noPatrimonialExternalParking: 'extérieur hors patrimoine',
				noRentExternalParking: 'extérieur non louable',
				simpleExternalParking: 'extérieur simple',
				bicycleParking: 'vélos',
				twoPiecesPavillon: 'pavillon 2 pièces',
				fourPiecesPavillon: 'pavillon 4 pièces',
				fivePiecesPavillon: 'pavillon 5 pièces',
				sixPiecesPavillon: 'pavillon 6 pièces',
				sevenPiecesPavillon: 'pavillon 7 pièces',
				psy: 'psychiatrie',
				stock: 'réserve',
				stocks: 'réserves',
				restaurationInterEnterprises: 'restaurant Inter Entreprises',
				restaurationInter_Enterprises: 'restaurant Inter-entreprises',
				chillRoom: 'salle de détente',
				meetingRoom: 'salle de réunion',
				sportRoom: 'salle de sport',
				healthAndReeducation: 'soins de Suite et Rééducation',
				studio: 'studio',
				t1: 'T1',
				t1Bis: 'T1 Bis',
				t2: 'T2',
				t3: 'T3',
				t4: 'T4',
				t5: 'T5',
				t6: 'T6',
				t8: 'T8',
				outside: 'terrain',
				coloc: 'colocation',
				bigFlat: 'grand appartement',
				parkingExterieurMoto: 'parking extérieur moto',
				parkingBorneElectrique: 'parking borne électrique',
				parkingCouvertTripe: 'parking couvert triple'
			}
		},
		summary: {
			title: 'Récapitulatif de votre demande',
			subtitle: 'L’appartement et/ou le parking vous seront réservés une fois que nous aurons validé votre dossier.',
			noFees: 'Hors charges',
			monthlyPayment: {
				title: 'Votre règlement mensuel pour le bien <span>{reference}</span> comprend :',
				principalPrice: {
					label: 'Loyer principal',
					tooltip: 'Il s\'agit du montant du loyer mensuel sans les charges. Le premier loyer sera à régler lors de la signature du bail.'
				},
				provisionFees: {
					label: 'Provision pour charges',
					tooltip: 'La provision de charges comprend la partie des dépenses générales de l\'immeuble (entretien des parties communes notamment) ainsi que les dépenses relatives à votre appartement (eau, chauffage collectif, etc.) que vous devrez payer.'
				},
				total: {
					label: 'Total mensuel',
					tooltip: ' '
				}
			},
			initialPayment: {
				title: 'Votre règlement initial comprend :',
				tooltip: 'Votre premier loyer sera également à régler lors de la signature.',
				fees: {
					value: '1 mois de Loyer Hors Charges'
				},
				apartment: {
					label: 'Dépôt de garantie appartement',
					tooltip: 'Pour votre appartement, le dépôt de garantie correspond à un mois de loyer hors charge. Il permet de couvrir d’éventuelles dégradations lors de l’état des lieux de sortie. Si tout va bien, nous vous le restituons intégralement sous un mois au moment de votre départ.'
				},
				parking: {
					label: 'Dépôt de garantie parking',
					tooltip: 'Le dépôt de garantie correspond à un mois de loyer hors charges.'
				},
				honorary: {
					label: 'Honoraires de commercialisation',
					tooltip: 'Retrouvez <a>ici</a> le barème explicatif'
				}
			}
		},
		promoCode: {
			placeholder: 'Code privilège',
			description: 'Le code privilège sera pris en compte lors de la validation de votre dossier'
		},
		type: {
			apartment: 'Appartement',
			parking: 'Parking'
		}
	},
	residence: {
		autreResidence: {
			voirFiche: 'Voir la fiche'
		}
	},
	offre: {
		menuAncre: {
			tarification: '{loyer} € <sup>CC / mois</sup>',
			tarificationMobil: '{loyer} € <span>CC / mois</span>'
		},
		typeLocation: {
			apartment: 'LOCATION APPARTEMENT',
			parking: 'LOCATION PARKING'
		},
		genre: {
			pieces2: 'Appartement 2 pièces',
			pieces3: 'Appartement 3 pièces',
			pieces4: 'Appartement 4 pièces',
			pieces5: 'Appartement 5 pièces',
			pieces6: 'Appartement 6 pièces',
			pieces7: 'Appartement 7 pièces',
			chambre: 'Appartement chambre',
			studio: 'Appartement studio',
			t1: 'Appartement T1',
			t1bis: 'Appartement T1-Bis',
			t2: 'Appartement T2',
			t3: 'Appartement T3',
			t4: 'Appartement T4',
			t5: 'Appartement T5',
			t6: 'Appartement T6',
			t8: 'Appartement T8'
		},
		descriptif: {
			titre: 'DESCRIPTIF'
		},
		loyer: {
			titre: 'LOYER'
		},
		quartier: {
			titre: 'LE QUARTIER'
		},
		residence: {
			titre: 'LA RÉSIDENCE',
			tag: 'RÉSIDENCE',
			lesPlus: 'Les {image} de votre résidence'
		},
		photos: {
			nbPhotos: '{nbPhotos} photos',
			plan: 'Plan du bien',
			visite: 'Visite 3D'
		},
		caracteristiques: {
			prix: {
				label: 'Loyer / mois',
				valeur: '{prix} {br} Charges comprises'
			},
			available: 'Disponible',
			dateDisponibilite: 'Disponible le {date}',
			disponibleMaintenant: 'Disponible',
			bouton: {
				select: 'Sélectionner cette offre'
			},
			reference: 'Référence : {ref}'
		},
		description: {
			titre: {
				apartment: 'Description de l\'appartement à louer',
				parking: 'Description du parking à louer'
			}
		},
		atouts: {
			titre: 'Les atouts de ce bien',
			bouton: 'Afficher plus d\'atouts'
		},
		tarification: {
			titre: 'Conditions tarifaires',
			mensuel: 'Le règlement mensuel est de :',
			chargesComprises: 'Charges comprises',
			dont: 'Dont',
			provisionCharges: 'Provisions sur charges',
			modeReglement: 'Le mode de règlement des charges est par provisions avec régularisation annuelle',
			loyerEncadre: 'Zone soumise à encadrement de loyer',
			loyerBase: 'Loyer de base',
			loyerMajore: 'Loyer de référence majoré',
			titreHonoraires: 'Le règlement initial comprend les honoraires et le dépôt de garantie :',
			honoraires: 'Honoraires TTC à la charge du locataire',
			edl: 'État des lieux',
			depotGarantie: 'Dépôt de garantie (un mois de loyer hors charges)',
			complementLoyer: 'Complément de loyer',
			montant: '{montant} €',
			montantM2: '{montant} € ({prixm2} €/m²)',
			georisques: 'Les informations sur les risques auxquels ce bien est exposé sont disponibles sur le site Géorisques : www.georisques.gouv.fr'
		},
		offresLiees: {
			titre: {
				apartment: '<strong>Découvrez aussi</strong> ces appartements à louer',
				parking: '<strong>Découvrez aussi</strong> ces parking à louer'
			},
			surTitre: {
				apartment: 'Appartement {genre}',
				parking: 'Parking {genre}'
			},
			tarification: {
				loyer: '{loyer} € <sup>CC</sup>'
			},
			boutonVoirapartment: 'Voir nos appartements à louer',
			boutonVoirbiens: 'Voir nos biens à louer',
			boutonVoirparking: 'Voir nos parkings à louer'
		},
		chauffageEtDiagnostics: {
			titre: 'Chauffage et diagnostics',
			emissionGazSerreBilan: {
				titre: 'Indice d’émission de gaz à effet de serre (GES)',
				valeur: '<span>{valeur}</span>{br} kg CO2/m2 an'
			},
			consommationEnergetiqueBilan: {
				titre: 'Diagnostic de performance énergétique (DPE)',
				valeur: '<span>{valeur}</span>{br} kWh/m2 an'
			}
		}
	},
	recherche: {
		aucunResultat: {
			tous: '<span>Aucun appartement</span> n\'est disponible pour le moment dans cette résidence.',
			autre: '<span>Aucun appartement</span> de cette typologie n\'est disponible pour le moment dans cette résidence.'
		},
		aucunResultatTitre: '<span>Aucun bien</span> disponible ne correspond à vos critères.',
		aucunResultatTexte: 'Revenez nous voir régulièrement, de nouveaux biens peuvent se libérer à tout moment.',
		aucunResultatResidenceTexte: 'Revenez nous voir régulièrement, de nouveaux biens peuvent se libérer à tout moment.',
		nombreOfrreAucunResultat: '<strong>0</strong> logement disponible',
		nombreOffre: '<strong>{nb}</strong> biens disponibles',
		afficherListe: 'Afficher la liste',
		afficherCarte: 'Afficher la carte',
		resultatsApprochants: {
			titre: 'Ces <span>biens</span> pourraient aussi vous intéresser'
		}
	},
	resultatsRecherche: {
		meta: {
			title: 'Résultats de recherche',
			description: 'Résultats de recherche'
		},
		menu: {
			location: {
				placeholder: 'Localisation',
				label: 'Où souhaitez-vous chercher votre bien ?',
				paris: 'Paris (75)',
				paris1: 'Paris 1er (75001)',
				paris2: 'Paris 2ème (75002)',
				paris3: 'Paris 3ème (75003)',
				paris7: 'Paris 7ème (75007)',
				paris8: 'Paris 8ème (75008)',
				paris9: 'Paris 9ème (75009)',
				paris11: 'Paris 11ème (75011)',
				paris12: 'Paris 12ème (75012)',
				paris13: 'Paris 13ème (75013)',
				paris14: 'Paris 14ème (75014)',
				paris15: 'Paris 15ème (75015)',
				paris16: 'Paris 16ème (75016)',
				paris17: 'Paris 17ème (75017)',
				paris18: 'Paris 18ème (75018)',
				paris20: 'Paris 20ème (75020)',
				defense: 'Paris Ouest La Défense (92)',
				boulogne: 'Boulogne (92100)',
				avray: 'Ville d\'Avray (92410)',
				bordeaux: 'Bordeaux (33)'
			},
			typeBien: {
				placeholder: 'Types de bien',
				label: 'Quel est votre projet de location ?',
				studio: 'Studio',
				chambre: 'Chambre',
				piece2: '2 pièces',
				piece3: '3 pièces',
				piece4: '4 pièces',
				piece5: '5 pièces',
				piece6: '6 pièces et plus',
				parkingVoiture: 'Parking voiture',
				parkingMoto: 'Parking moto'
			},
			budget: {
				placeholder: 'Budget',
				label: 'Pour quel budget ?',
				min: {
					label: 'Min',
					formLabel: '{montantMin} € min'
				},
				max: {
					label: 'Max',
					formLabel: '{montantMax} € max'
				}
			},
			rechercheAvancee: {
				placeholder: 'Recherche avancée',
				meuble: {
					label: 'Appartement meublé ?',
					option: 'Meublé'
				},
				surface: {
					label: 'Quelle surface ?',
					min: {
						label: 'Min'
					},
					max: {
						label: 'Max'
					}
				},
				combienDeChambre: {
					label: 'Combien de chambres ?',
					une: '1',
					deux: '2',
					trois: '3',
					quatre: '4',
					cinq: '5+'
				},
				quelEtage: {
					label: 'À quel étage ?',
					rdc: 'RDC',
					un: '1',
					deux: '2',
					trois: '3',
					quatre: '4',
					cinq: '5',
					six: '6+'
				},
				dernierEtage: {
					label: 'Dernier étage'
				},
				prestation: {
					label: 'Choisissez vos prestations',
					balcon: 'Balcon',
					terrasse: 'Terrasse',
					loggia: 'Loggia',
					jardinPrivatif: 'Jardin privatif',
					gardien: 'Gardien',
					localVelos: 'Local vélos',
					espacesVerts: 'Espaces verts',
					ascenseur: 'Ascenseur',
					cave: 'Cave',
					possibiliteParking: 'Possibilité parking',
					cuisineSemiEquipee: 'Cuisine semi-équipée',
					cuisineOuverte: 'Cuisine ouverte',
					cuisineSeparee: 'Cuisine séparée',
					voirPlus: 'Afficher plus',
					voirMoins: 'Afficher moins'
				},
				parking: {
					label: 'Souhaitez-vous un parking ?',
					boxPetit: 'Box petit',
					boxSimple: 'Box simple',
					boxDouble: 'Box double',
					parkingCouvertPetit: 'Parking couvert petit',
					parkingCouvertSimple: 'Parking couvert simple',
					parkingCouvertDouble: 'Parking couvert double',
					parkingCouvertTripe: 'Parking couvert triple',
					parkingExterieurSimple: 'Parking extérieur simple',
					parkingExterieurDouble: 'Parking extérieur double',
					parkingBorneElectrique: 'Parking borne électrique',
					boxMoto: 'Box moto',
					parkingCouvertMoto: 'Parking couvert moto',
					parkingExterieurMoto: 'Parking extérieur moto'
				},
				pmr: {
					label: 'Accessible aux personnes à mobilité réduite (PMR)',
					option: 'PMR'
				},
				reference: {
					title: 'Nom de la Résidence ou "RefRésidence-RefLot"',
					label: '(exemple : "Dareau" ou "424-C1113")'
				}
			},
			modifierRecherche: 'Modifier ma recherche',
			commencerRecherche: 'Commencer votre recherche',
			toutEffacer: 'Tout effacer',
			rechercher: 'Rechercher'
		},
		tri: {
			prefix: 'Trier par :',
			disponibilite: 'Disponibilité',
			nouveaute: 'Nouveauté',
			prixCroissant: 'Prix croissant',
			prixDecroissant: 'Prix décroissant',
			offreSpeciale: 'Offre spéciale'
		}
	},
	client: {
		lastname: 'Nom',
		firstname: 'Prénom',
		email: 'Email',
		phone: 'Téléphone'
	},
	404: {
		filAriane: 'PAGE 404',
		titre: 'OUPS !',
		sousTitre: 'On n\'a rien trouvé à cette adresse...',
		texte: 'En revanche, on peut vous faire découvrir tous nos appartements disponibles à la location aujourd\'hui.',
		bouton: 'Voir nos appartements à louer'
	},
	tronquageTexte: {
		lirePlus: 'Lire plus +'
	},
	blocLiens: {
		decouvrezAussi: 'Découvrez aussi',
		voirPlus: 'Voir plus +'
	},
	planificationVisite: {
		title: 'Planification de la visite'
	},
	rechercheContact: {
		title: 'Recherche du contact',
		recherche: {
			label: 'Saisir une recherche',
			placeholder: 'Nom, Email, Téléphone'
		},
		resultats: {
			table: {
				nom: 'Nom',
				prenom: 'Prénom',
				email: 'Email',
				telephone: 'Téléphone',
				typeContact: 'Type de contact',
				origine: 'Origine',
				empty: 'Aucun contact ne correspond à votre recherche.'
			}
		},
		btnCreation: 'Créer un contact'
	},
	contact: {
		type: {
			LEAD_RESIDENTIEL: 'Lead résidentiel',
			CLIENT_POTENTIEL_RESIDENTIEL: 'Client potentiel résidentiel',
			CLIENT_RESIDENTIEL: 'Client résidentiel',
			SUSPECT_RESIDENTIEL: 'Suspect résidentiel',
			SOCIETE_LEAD_RESIDENTIEL: 'Société lead résidentiel',
			SOCIETE_CLIENT_POTENTIEL_RESIDENTIEL: 'Société client potentiel résidentiel',
			SOCIETE_CLIENT_RESIDENTIEL: 'Société client résidentiel',
			SOCIETE_SUSPECT_RESIDENTIEL: 'Société suspect résidentiel'
		},
		origine: {
			SE_LOGER: 'Se loger',
			BIEN_ICI: 'Bien ici',
			LE_BON_COIN: 'Le Bon Coin',
			SITE_YFR: 'Site YFR',
			SITEL: 'SITEL',
			PANNEAU_SUR_RESIDENCE: 'Panneau sur résidence',
			RELATION: 'Relation',
			AUTRE: 'Autre'
		}
	},
	detailsContact: {
		title: 'Coordonnées de l\'interlocuteur commercial',
		dossier: {
			status: {
				progress: 'En cours de constitution',
				recycling: 'En recyclage',
				complete: 'En cours d\'étude',
				toUpdate: 'Demande incomplète',
				accepted: 'Demande acceptée',
				refused: 'Demande non retenue',
				abandoned: 'Votre demande de location est annulée'
			}
		},
		informations: {
			prospect: {
				description: 'Le contact est déjà prospect.{br}',
				subtitle: 'Son dossier le plus récent est le dossier suivant :',
				reference: 'Référence : {reference}',
				residence: 'Résidence : {residence}',
				lot: 'Lot : {reference}',
				date: 'Date à laquelle il a été initié : {createdon}',
				statut: 'Statut : {statut}',
				invite: 'Invitez-le à accéder à son espace ou communiquez-lui les coordonnées suivantes de l\'Attaché Commercial :'
			},
			client: {
				description: 'Le contact est déjà client.{br}',
				subtitle: 'Son bail le plus récent est le bail suivant :',
				reference: 'Référence : {reference}',
				residence: 'Résidence : {residence}',
				lot: 'Lot : {reference}',
				dateEffet: 'Date d\'effet : {date_effet}',
				dateConge: 'Date de congé : {date_conge}',
				statut: 'Statut : {statut}',
				invite: 'Invitez-le à accéder à son espace client et à utiliser la fonctionnalité de changement d\'appartement / parking ou communiquez-lui les coordonnées suivantes du Gestionnaire Locatif :'
			},
			default: {
				nom: 'Numéro d\'appel YouFirst',
				telephone: '01 40 40 18 50',
				objet: 'Demande d\'information du contact {prenom} {nom}'
			}
		},
		back: 'Retour à la liste des contacts'
	},
	visites: {
		popin: {
			connexion: {
				titre: 'Restons connectés',
				description: 'Une connexion est nécessaire pour que nous puissions traiter votre demande de visite. \nVous n\'avez pas encore de compte ? Vous allez pouvoir en créer un en quelques clics.'
			},
			refus: {
				titre: 'Réservation non autorisée',
				descriptionDejaRDV: 'Vous avez déjà pris rendez-vous pour visiter ce bien. Vous pouvez modifier ce rendez-vous si le créneau ne vous convient plus.',
				descriptionMemeResidence: 'Vous ne pouvez pas planifier plus de deux visites dans la même résidence.'
			},
			priseRDV: {
				recapitulatif: {
					titre: 'Bien que vous souhaitez visiter',
					switch: 'Je souhaite également visiter un parking (honoraires parking offerts)',
					parking: 'Pensez à amener votre voiture pour essayer la place de parking'
				},
				calendrier: {
					titre: 'Choisissez votre date de rendez-vous',
					bouton: 'Confirmer votre rendez-vous',
					erreur: 'Erreur lors de la récupération des créneaux du bien'
				},
				info: 'Pour être éligible à un appartement à louer, vos revenus mensuels doivent être 3 fois supérieur au montant du loyer. Une précaution pour préserver votre qualité de vie.',
				erreurs: {
					creneauAvecLot: 'Le créneau demandé n\'est malheureusement plus disponible. Merci d\'en sélectionner un nouveau.',
					creneauAvecOwner: 'Le créneau demandé n\'est malheureusement plus disponible. Merci d\'en sélectionner un nouveau.',
					creneauIndisponible: 'Le créneau demandé n\'est malheureusement plus disponible. Merci d\'en sélectionner un nouveau.',
					creneauAvecProspect: 'Vous avez déjà une visite prévue sur ce créneau.'
				}
			},
			confirmationRDV: {
				titre: 'Votre demande de visite a bien été confirmée',
				texte: 'À tout moment, vous pouvez consulter votre liste de rendez-vous sur votre espace connecté.',
				boutonConsulter: 'Consulter mes visites',
				boutonAccueil: 'Retour à l\'accueil'
			},
			confirmationErreurRDV: {
				titre: 'Réservation indisponible',
				texte: 'La réservation sur ce créneau n\'est pas possible pour l\'instant. Nous allons actualiser les disponibilités pour vous permettre de sélectionner un autre horaire.'
			},
			annulationRDV: {
				titre: 'Annulation de visite',
				titreAnnulee: 'Annulation prise en compte',
				description: 'Votre visite sera annulée',
				descriptionAnnulee: 'Votre visite a bien été annulée',
				conserverVisite: 'Conserver la visite',
				annulerVisite: 'Annuler la visite'
			},
			RDVTelephone: {
				titre: 'Rendez-vous par téléphone',
				texte: 'Veuillez contacter le {telephone} pour modifier votre visite'
			},
			visiteNonRealisee: {
				titre: 'Visite non réalisée',
				texte: 'Vous n\'avez pas encore visité ce bien. N\'attendez plus et réservez vite votre visite pour déposer votre demande de location.'
			},
			annoncePlusDisponible: {
				titre: 'Annonce plus disponible',
				texte: 'L\'annonce n\'est plus disponible. En revanche, on peut vous faire découvrir tous nos biens disponibles à la location aujourd\'hui.'
			},
			dossierExistant: {
				titre: 'Demande en cours',
				texte: 'Vous avez déjà une demande de location en cours. Cette annonce ne vous intéresse plus ? Annulez d\'abord la demande en cours pour en déposer une nouvelle.'
			},
			dossierRefuseAnnule: {
				titreRefuse: 'Dossier refusé',
				titreAnnule: 'Demande de réservation annulée',
				texteRefuse: 'Votre demande de location n\'a pas été retenue.{br}D\'autres biens sont disponibles à la location aujourd\'hui, découvrez-les et réservez vitre votre visite.',
				texteAnnule: 'Votre demande de location a été annulée.{br}D\'autres biens sont disponibles à la location aujourd\'hui, découvrez-les et réservez vite votre visite.'
			},
			annulationDemande: {
				titre: 'Annulation de demande',
				titreAnnulee: 'Annulation prise en compte',
				description: 'Votre demande de location sera annulée. Êtes-vous sûr de bien vouloir annuler votre demande ?',
				descriptionAnnulee: 'Votre demande a bien été annulée',
				conserverDemande: 'Conserver la demande',
				annulerDemande: 'Annuler la demande',
				erreurs: {
					champs: 'Veuillez envoyer toutes les informations nécessaires à la modification',
					annulationDemande: 'Erreur lors de l\'annulation de la demande'
				}
			},
			parkingNonDisponible: {
				titre: 'Parking plus disponible',
				texte: 'Le parking que vous avez visité n\'est plus disponible. Votre YouFirst Manager se rapprochera de vous afin de vous en proposer un autre si possible. Vous pouvez maintenant avancer dans le dépôt de votre dossier pour l\'appartement.'
			},
			refusRDV: {
				commentaire: 'Commentaire',
				raisons: {
					reflechir: 'Besoin de réfléchir',
					incomprehension: 'Incompréhension de l\'annonce',
					incompatible: 'Pas de date compatible'
				},
				bouton: 'Refuser le rendez-vous'
			}
		}
	},
	creationContact: {
		title: 'Création du contact',
		prospectType: {
			contact: 'Particulier',
			account: 'Professionnel'
		},
		origin: {
			seLoger: 'Se loger',
			bienIci: 'Bien ici',
			leBonCoin: 'Le bon coin',
			panneau: 'Panneau sur résidence',
			relation: 'Relation',
			autre: 'Autre'
		},
		contactForm: {
			prospectType: 'Type de contact',
			civility: 'Civilité',
			miss: 'Mme',
			mister: 'M.',
			lastname: 'Nom',
			firstname: 'Prénom',
			email: 'Courriel',
			phoneMobile: 'Téléphone mobile',
			phoneFix: 'Téléphone fixe',
			socialReason: 'Raison Sociale',
			origin: 'Origine du contact'
		},
		btnCreation: 'Créer le contact'
	}
}

export default flatten<typeof target, ModelTranslations>(target)